import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  templateUrl: './colorbox-inline.component.html',
  styleUrls: ['./colorbox-inline.component.less']
})
export class ColorboxInlineComponent implements OnInit {

  @Input()
  public Title: string = null;

  @Input()
  public CloseText: string = 'Close';

  @Input()
  public Content: string;

  @Output()
  public OnClose: EventEmitter<void> = new EventEmitter();
  
  constructor(public modal: BsModalRef) {
  }

  public ngOnInit(): void {
  }

  public Close(): void {
    this.OnClose.emit();
    this.modal.hide();
  }
}
